import { html } from "uhtml";

// Node structure
// title
// bold
// italic
// pageNumber
// items

function handleExpand(event) {
	const parent = event.target.parentElement;
	const list = parent.querySelector("ol");
	if (list) {
		list.hidden = !list.hidden;
		list.classList.toggle("active");
	}
	event.target.setAttribute("aria-expanded", list.hidden ? "false" : "true");
}

function pdfOutlineLabel(node) {
	// Entries without an in-document destination (section headings, or
	// links to external URLs, which the reader does not follow) are shown
	// as plain text rather than as a link to "#page=null".
	if (!node.pageNumber) {
		return html`<span>${node.title}</span>`;
	}
	return html`<span><a href="${`#page=${node.pageNumber}`}">${node.title}</a></span>`;
}

function pdfOutlineNode(node) {
	if (node.items && node.items.length !== 0) {
		return html`<li class="contents-parent"><button type="button" class="toc-expand-button" aria-expanded="false" @click=${handleExpand}>+</button>${pdfOutlineLabel(node)}${pdfOutlineList(node.items, true)}</li>`;
	} else {
		return html`<li class="contents-node"><span></span>${pdfOutlineLabel(node)}</li>`;
	}
}

function pdfOutlineList(nodeArray, nested = false) {
	return html`<ol ?hidden=${nested} class="${nested ? "toc-collapsed" : ""}">${nodeArray.map((item) => pdfOutlineNode(item))}</ol>`;
}

export function pdfOutlineTree(outline) {
	return pdfOutlineList(outline);
}
